export default __webpack_public_path__ + "static/simon-869978ec95b38b8f84dcc5789e0cbfea.webp";